import React from 'react';
import styled from 'styled-components';
import { darken } from 'polished';
import Status from '../types/enum/Status';
import _theme from '../styles/theme';

export type ButtonProps = {
  theme: {
    [key: string]: any
  },
  children?: React.ReactNode;
  status?: Status;
  isFullwidth?: boolean;
  isOutline?: boolean;
  disabled?: boolean;
}

type ButtonFullProps = {
  backgroundColor?: string;
  borderColor?: string;
  fontColor?: string;
} & ButtonProps;

const Button = styled.button.attrs(({
  theme,
  children,
  status = Status.default,
  isOutline = true,
  disabled,
  isFullwidth = false,
  // backgroundColor = _theme.color.lightBackground,
  // borderColor,
  // fontColor,
}: ButtonProps) => {
  let backgroundColor: string;
  let borderColor: string;
  let fontColor: string;
  if (status === Status.default) {
    backgroundColor = isOutline ? 'transparent' : _theme.color.white;
    borderColor = isOutline ? _theme.color.lightBlueGray300 : 'transparent';
    fontColor = _theme.color.darkBlueGray900;
  } else {
    backgroundColor = isOutline ? 'transparent' : _theme.color[status];
    borderColor = isOutline ? _theme.color[status] : 'transparent';
    fontColor = isOutline ? _theme.color[status] : _theme.color.white;
  }
  return ({
    theme,
    backgroundColor,
    borderColor,
    fontColor,
  });
}) <ButtonFullProps>`
  justify-content: center;
  align-items: center;
  display: inline-flex;
  box-sizing: border-box;
  min-height: 40px;
  ${({ isFullwidth }) => (isFullwidth ? 'width: 100%;' : '')}
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ fontColor }) => fontColor};
  ${({ theme }) => _theme.typography.paragraph};
  padding: 3px 12px;
  border: 1px solid ${({ borderColor }) => borderColor};
  border-radius: 4px;
  line-height: 150%;
  outline: none;
  cursor: pointer;
  transition: 0.1s all;
  text-decoration:none;
  box-shadow: ${({ theme, status }) => theme.shadow(2, Status.default)};
  &:hover {
    color: ${({ theme, fontColor }) => fontColor};
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export default Button;
